import { render, staticRenderFns } from "./varmalaina.vue?vue&type=template&id=32a2aec5&"
import script from "./varmalaina.vue?vue&type=script&lang=js&"
export * from "./varmalaina.vue?vue&type=script&lang=js&"
import style0 from "./varmalaina.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports